import React, { lazy } from 'react';

// B端页面全部懒加载，避免影响 C 端首屏与资源体积
const AdminLogin = lazy(() => import('../pages/admin/Login'));
const AdminRegister = lazy(() => import('../pages/admin/Register'));
const AdminHome = lazy(() => import('../pages/admin/Home'));
const AdminHomeContent = lazy(() => import('../pages/admin/HomeContent'));
const AdminUsers = lazy(() => import('../pages/admin/Users'));
const AdminUserDetail = lazy(() => import('../pages/admin/UserDetail'));
const AdminUserEdit = lazy(() => import('../pages/admin/UserEdit'));
const AdminProfile = lazy(() => import('../pages/admin/Profile'));
const AdminTeam = lazy(() => import('../pages/admin/Team'));

// B端（后台管理）路由配置
const adminRoutes = [
  { path: 'login', element: <AdminLogin /> },
  { path: 'register', element: <AdminRegister /> },
  {
    path: 'home',
    element: <AdminHome />,
    children: [
      { index: true, element: <AdminHomeContent /> },
    ],
  },
  {
    path: 'users',
    element: <AdminHome />,
    children: [
      { index: true, element: <AdminUsers /> },
    ],
  },
  {
    path: 'user/detail',
    element: <AdminHome />,
    children: [
      { index: true, element: <AdminUserDetail /> },
    ],
  },
  {
    path: 'user/edit',
    element: <AdminHome />,
    children: [
      { index: true, element: <AdminUserEdit /> },
    ],
  },
  {
    path: 'profile',
    element: <AdminHome />,
    children: [
      { index: true, element: <AdminProfile /> },
    ],
  },
  {
    path: 'team',
    element: <AdminHome />,
    children: [
      { index: true, element: <AdminTeam /> },
    ],
  },
];

export default adminRoutes;

